





















import Vue from 'vue';
import {TitleDropdownOption} from './TitleDropdownOption'

export default Vue.extend({
  name: 'TitleDropdownPicker',
  props: {
    options :  {
      type: Array as () => any[]
    },
    value : { type: Object },
  },
  data() {
    return {
      showDropdown: false,
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectItem(option:TitleDropdownOption) {
      if(option!==this.value) {
        this.$emit('input', option);
      } else{
        this.toggleDropdown();
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/TitleDropdownPicker.vue